import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import Icon from '../../../atoms/Icon'
import { useAppContext } from '../../../../redux/slices/appContext'

const useStyles = makeStyles((theme) => ({
  marketValueText: {
    backgroundColor: 'var(--color-primary-500)',
    width: '36px',
    height: '36px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'var(--border-radius-round)',
    marginTop: '5px'
  },
  icon: {
    fill: 'var(--color-neutral-050)'
  }
}))

const ClientConversation = ({ text, className, style }) => {
  const classes = useStyles()
  const { clientId } = useAppContext()

  return (
    <Link to={`/conversations/c/${clientId}`} className={clsx(classes.marketValueText, className)} title={text} style={style}>
      <Icon name='chat' additionalClasses={classes.icon} />
    </Link>
  )
}

ClientConversation.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

ClientConversation.defaultProps = {
  text: 'Start Conversation'
}

export default ClientConversation
